import type { Resource, Permission, UserResponse } from "libs/apiClient";

export function hasPermissionToResource(user: UserResponse, wantedResource: Resource, wantedPermission: Permission ) {
	return !!user.permissions?.find(({resource, permission}) => {
		//@ts-ignore
		return (resource === wantedResource && permission === wantedPermission) || (resource === "all" && permission === "all")
	})
}
